<template>
  <v-data-table
    :headers="sharkGroupHeaders"
    :items="sharkGroupData"
    :loading="_loading"
    :footer-props="{
      'items-per-page-options': [50, 100, 150]
    }"
    class="elevation-1"
    :server-items-length="total"
    :options.sync="options"
    @click:row="goTo"
    @update:options="_getReportInstances(options)"
  >
    <template v-slot:item.launch_mode="{ item }">
      {{ formatLaunchMode(item.launch_mode) }}
    </template>
    <template v-slot:item.last_activity="{ item }">
      {{ formatDate(item.last_activity, "Never Active") }}
    </template>
    <template v-slot:item.group_name="{ item }">
      <div class="text-capitalize">
        {{ item.group_name }}
      </div>
    </template>
    <template v-slot:item.active="{ item }">
      {{ active(item.last_activity) }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import Options from '@/mixins/Options';
import FormatDate from '@/mixins/FormatDate';
import FormatLaunchMode from '@/mixins/FormatLaunchMode';

export default {
  props: ['sharkGroupData'],
  mixins: [Options, FormatDate, FormatLaunchMode],
  data() {
    return {
      sharkGroupHeaders: [
        { text: 'Course', value: 'group_name' },
        { text: 'Launch Mode', value: 'launch_mode' },
        { text: 'Active', value: 'active' },
        { text: 'Total Active Golf Cars', value: 'total_screens' },
        // { text: "City, State", value: "city" },
        // { text: "Contact", value: "contact_name" },
        { text: 'Last Activity', value: 'last_activity' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
      _loading: 'reports/getScreensTableLoading',
    }),
    total() {
      return this.sharkGroupData[0]
        ? parseInt(this.sharkGroupData[0].total)
        : 0;
    },
  },
  methods: {
    ...mapActions({
      _getReportInstances: 'reports/acquireSessions',
    }),
    goTo(item) {
      this.$router.push(
        `/${this._client.client_name.toLowerCase()}/groups/${item.uuid}`,
      );
    },
    active(date) {
      return moment(date)
        .local()
        .isSame(moment(), 'day')
        ? 'Yes'
        : 'No';
    },
  },
};
</script>
